import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "KuÅ¾a?",
  "description": "",
  "published": "2007-05-19T00:00:00.000Z",
  "redirect_from": ["/blog/kua/swizec/206"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://img153.imageshack.us/my.php?image=bigdoggieim5.jpg"
      }}><img parentName="a" {...{
          "src": "https://img153.imageshack.us/img153/9017/bigdoggieim5.th.jpg",
          "alt": "Free Image Hosting at www.ImageShack.us"
        }}></img></a></p>
    <p>{`O tem impresivno velikem kuÅ¾iju se paÄ ne da veliko povedati. Pošast je najveÄji oz. najvolumnejši kuÅ¾a na sveti, vsaj tako pravijo pobje iz Guinnessove knjige rekordov. Kar je najbolj nenavadno je, da naj bi stvar imela še dve leti rasti pred seboj.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      